import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';

export type ConjunctionProps = {
  pId: number;
  sId: number;
  tca: string;
  dca: number;
  from: string;
  to: string;
  probability: string;
};

type GeoProps = {
  latitude: number;
  longitude: number;
  height: number;
};

type ConjunctionStore = {
  conjunction: ConjunctionProps | null;
  geoData: GeoProps | null;
  setConjunction: (c: ConjunctionProps | null) => void;
  setGeoData: (g: GeoProps | null) => void;
  clear: () => void;
};

const store = (set) => ({
  conjunction: null,
  geoData: null,
  setConjunction: (c) => {
    set({ conjunction: c });
  },
  setGeoData: (g) => {
    set({ geoData: g });
  },
  clear: () => {
    set({ conjunction: null });
  },
});

export const useConjunctionStore = create<ConjunctionStore>(store);
